var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 83,
    viewBox: "0 0 79 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0759 9.47154C46.8803 5.9185 44.7706 2.35806 41.3636 1.51909C37.9565 0.680116 34.5424 2.88031 33.7379 6.43335C32.9334 9.98639 35.0432 13.5468 38.4502 14.3858C41.8572 15.2248 45.2714 13.0246 46.0759 9.47154Z",
    fill: "#AEAEAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M46.1546 76.2847C46.7155 72.6809 44.3687 69.2853 40.913 68.7004C37.4574 68.1155 34.2013 70.5629 33.6405 74.1667C33.0796 77.7704 35.4264 81.166 38.8821 81.7509C42.3378 82.3358 45.5938 79.8885 46.1546 76.2847Z",
    fill: "#AEAEAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.6833 48.1767C76.1722 47.8756 78.7665 44.6819 78.4777 41.0435C78.189 37.405 75.1266 34.6995 71.6376 35.0007C68.1487 35.3018 65.5544 38.4955 65.8431 42.1339C66.1319 45.7724 69.1943 48.4779 72.6833 48.1767Z",
    fill: "#AEAEAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M13.8016 43.1242C14.6134 39.573 12.511 36.0078 9.10575 35.1612C5.70048 34.3145 2.28182 36.507 1.46998 40.0582C0.658131 43.6095 2.76052 47.1746 6.16579 48.0213C9.57107 48.8679 12.9897 46.6754 13.8016 43.1242Z",
    fill: "#AEAEAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.1341 63.4275C74.6095 60.8459 74.6096 56.6604 72.1341 54.0789C69.6587 51.4973 65.6452 51.4973 63.1697 54.0789C60.6943 56.6604 60.6943 60.8459 63.1697 63.4275C65.6452 66.009 69.6586 66.009 72.1341 63.4275Z",
    fill: "#AEAEAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M13.1167 30.9525C16.578 30.4041 18.9577 27.0334 18.4318 23.4238C17.906 19.8142 14.6738 17.3325 11.2125 17.8809C7.75124 18.4292 5.37158 21.8 5.89741 25.4096C6.42324 29.0192 9.65543 31.5009 13.1167 30.9525Z",
    fill: "#AEAEAE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M16.6341 63.4255C19.1095 60.844 19.1095 56.6585 16.6341 54.0769C14.1586 51.4954 10.1451 51.4954 7.6697 54.0769C5.19425 56.6585 5.19425 60.844 7.6697 63.4255C10.1452 66.0071 14.1586 66.0071 16.6341 63.4255Z",
    fill: "#AEAEAE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M70.854 30.1055C73.8647 28.2397 74.8554 24.1871 73.0663 21.0474C71.2772 17.9076 67.3912 16.8744 64.3804 18.7402C61.3697 20.606 60.379 24.6586 62.1681 27.7983C63.9572 30.928 67.8433 31.9612 70.854 30.1055Z",
    fill: "#AEAEAE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.6602 74.1598C31.3724 70.98 30.2854 66.9475 27.2362 65.1619C24.1871 63.3764 20.3203 64.5099 18.6081 67.6898C16.8959 70.8696 17.9829 74.9021 21.0321 76.6877C24.0909 78.4732 27.948 77.3397 29.6602 74.1598Z",
    fill: "#AEAEAE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M58.4458 18.1909C61.5952 16.5966 62.9089 12.6416 61.3801 9.35728C59.8512 6.07294 56.0588 4.70293 52.9095 6.29727C49.7601 7.89161 48.4464 11.8466 49.9752 15.1309C51.504 18.4152 55.2964 19.7852 58.4458 18.1909Z",
    fill: "#AEAEAE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M50.1394 74.1598C48.4272 70.98 49.5141 66.9475 52.5633 65.1619C55.6125 63.3764 59.4793 64.5099 61.1915 67.6898C62.9036 70.8696 61.8167 74.9021 58.7675 76.6877C55.7087 78.4732 51.8515 77.3397 50.1394 74.1598Z",
    fill: "#AEAEAE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M25.5302 18.6907C28.9442 17.8828 31.0838 14.3416 30.309 10.7813C29.5343 7.22091 26.1386 4.98965 22.7246 5.79759C19.3106 6.60553 17.171 10.1467 17.9458 13.7071C18.7205 17.2674 22.1162 19.4987 25.5302 18.6907Z",
    fill: "#AEAEAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.6ad263e1a5da4896a4813e0245d2edcc.svg";
export { ForwardRef as ReactComponent };